import { cloudFrontOrigin } from "./config";

export const visitorManagementData = [
  {
    image: `${cloudFrontOrigin}vms-image-1.png`,
    headings: {
      1: ["Scan QR code in-front of the facility", "bulletActive"],
      2: ["Enter your details", "bulletInactive"],
      3: ["Enter COVID declaration form", "bulletInactive"],
      4: ["Request for entry access", "bulletInactive"],
      5: ["Use app to unlock", "bulletInactive"],
    },
  },
  {
    image: `${cloudFrontOrigin}vms-image-2.png`,
    headings: {
      1: ["Scan QR code in-front of the facility", "bulletActive"],
      2: ["Enter your details", "bulletActive"],
      3: ["Enter COVID declaration form", "bulletInactive"],
      4: ["Request for entry access", "bulletInactive"],
      5: ["Use app to unlock", "bulletInactive"],
    },
  },
  {
    image: `${cloudFrontOrigin}covid-dec_smt8ff.png`,
    headings: {
      1: ["Scan QR code in-front of the facility", "bulletActive"],
      2: ["Enter your details", "bulletActive"],
      3: ["Enter COVID declaration form", "bulletActive"],
      4: ["Request for entry access", "bulletInactive"],
      5: ["Use app to unlock", "bulletInactive"],
    },
  },
  {
    image: `${cloudFrontOrigin}otp-delivery_abwtgo.png`,
    headings: {
      1: ["Scan QR code in-front of the facility", "bulletActive"],
      2: ["Enter your details", "bulletActive"],
      3: ["Enter COVID declaration form", "bulletActive"],
      4: ["Request for entry access", "bulletActive"],
      5: ["Use app to unlock", "bulletInactive"],
    },
  },
  {
    image: `${cloudFrontOrigin}door_sbpqg4.png`,
    headings: {
      1: ["Scan QR code in-front of the facility", "bulletActive"],
      2: ["Enter your details", "bulletActive"],
      3: ["Enter COVID declaration form", "bulletActive"],
      4: ["Request for entry access", "bulletActive"],
      5: ["Use app to unlock", "bulletActive"],
    },
  },
];
